module.exports = __webpack_public_path__ + "static/media/WHB_Gif.2d65c96b.gif";